<script setup lang="ts">
import NewRateCard from './NewRateCard.vue'
import HScrollRow from '~/components/UI/HScrollRow.vue'

const { newRateList } = storeToRefs(useNewRatesStore())
</script>

<template>
  <div v-if="newRateList.length > 0"
    class="highlighted-rates relative w-full flex justify-center items-center bg-gradient-to-r from-[#4D63E1] to-[#AC5FE5] z-10"
    style="background-color: #7D61E3">
    <div class="xl:container relative w-full flex flex-col justify-center items-center gap-8 py-8">
      <h2 class="text-2xl sm:text-4xl text-center text-white font-bold">
        Nuove offerte
      </h2>
      <HScrollRow :scroll-by="340">
        <div v-for="data in newRateList" :key="data.id" class="flex-shrink-0 w-[280px] sm:w-[320px]">
          <NewRateCard :data="data" />
        </div>
      </HScrollRow>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.highlighted-rates {
  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
  }

  @media (min-width: 768px) {
    &:before {
      bottom: 0;
      left: 0;
      width: 75%;
      background: url('/images/wave/wave_1.svg') no-repeat left top / contain;
      background-blend-mode: multiply;
      mix-blend-mode: multiply;
    }
    &:after {
      top: 0;
      right: 0;
      background: url('/images/wave/wave_2.svg') no-repeat bottom / contain;
    }
  }

  @media (max-width: 769px) {
    &:after {
      top: 0;
      right: 0;
      background: url('/images/wave_primary.svg') no-repeat bottom / contain;
    }
  }
}
</style>
